import { translate as __ } from 'foremanReact/common/I18n';

export const ANSIBLE_KEY = 'Ansible';
export const SECONDARY_TABS = [
  { key: 'roles', title: __('Roles') },
  { key: 'variables', title: __('Variables') },
  { key: 'inventory', title: __('Inventory') },
  { key: 'jobs', title: __('Jobs') },
];



// WEBPACK FOOTER //
// /builddir/build/BUILDROOT/rubygem-foreman_ansible-9.0.1-1.fm3_4.el8.noarch/usr/share/gems/gems/foreman_ansible-9.0.1/webpack/components/AnsibleHostDetail/constants.js